import React, { useState, useEffect, useCallback } from 'react';
// Configuration
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
// Services
import { apiFetchData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
// Components
import AxiosError from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/axiosError';
import BreadCrumbs from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/breadcrumbs';
import MainTitle from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/mainTitle';
import disableElementService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/disableElementService';

import Loader from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/loader';

const pathExtension = pageConfig.aboutGuaranteesPage.initialPathExtension;

export default function AboutGuaranteesContent({ temporaryPublicResourcesSSR, publicResourcesSSR }) {
    const [publicResources, setPublicResources] = useState(
        temporaryPublicResourcesSSR || publicResourcesSSR || null,
    );
    const [errorMsg, setErrorMsg] = useState(null);
    const [isLoading, setIsLoading] = useState(null);

    const getData = useCallback(() => {
        setIsLoading(true);
        apiFetchData(pathExtension)
            .then((res) => {
                if (res.status === 200) {
                    setPublicResources(res.data);
                    return;
                }
                reportError(res);
            })
            .catch((err) => {
                setErrorMsg(err);
                reportError(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!publicResources) {
            getData();
        }
        disableElementService.removeServerSideRenderClass();
        window.isReactLoaded = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <BreadCrumbs breadcrumbs={publicResources?.breadcrumbs} breadcrumbsStructuredData={publicResources?.breadcrumbsStructuredData} isLoading={isLoading} skeletonMaxWidthPx={246} />
            {isLoading && <Loader />}
            {errorMsg && <AxiosError />}
            {publicResources && (
                <div>
                    <div className="row pageContent">
                        {publicResources.mainTitle && (
                            <div className="col-12">
                                <MainTitle title={publicResources.mainTitle} />
                            </div>
                        )}
                        <div className="col-md-12">
                            <h3 className="subheading">{publicResources.dataAccuracyTitle}</h3>
                            <div dangerouslySetInnerHTML={{ __html: publicResources.dataAccuracyText }} />
                            <h3 className="subheading">{publicResources.safePurchaseTitle}</h3>
                            <div className="row">
                                <div className="col-md-6 borderRight">
                                    <p><strong> {publicResources.safeBuyInsuranceSubTitle}</strong></p>
                                    <div dangerouslySetInnerHTML={{ __html: publicResources.safeBuyInsuranceText }} />
                                    <a href={publicResources.safeBuyInsuranceButtonURL} className="adr-btn-primary-md">
                                        {publicResources.safeBuyInsuranceButtonText}
                                    </a>
                                </div>
                                <div className="col-md-6">
                                    <p><strong> {publicResources.safeBuyUHPASubTitle}</strong></p>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: publicResources.safeBuyUHPAText }}
                                    />
                                    <img
                                        width={250}
                                        height={168}
                                        className="about-guarantees__uhpa-image"
                                        src={publicResources.safeBuyUHPAImage.sourceURL}
                                        alt={publicResources.safeBuyUHPAImage.altText}
                                        title={publicResources.safeBuyUHPAImage.titleText}
                                    />
                                </div>
                            </div>
                            <h3 className="subheading">{publicResources.bestBuyTitle}</h3>
                            <p><strong> {publicResources.safeBuyUHPASubTitle}</strong></p>
                            <div
                                className="about-guarantees__best-buy"
                                dangerouslySetInnerHTML={{ __html: publicResources.bestBuyText }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
